import { gql } from '@apollo/client';
import { queryClientSideGraphQL } from '../../../integration/graphql.client';

const QUERIES = {
  GET_USERNAME_OTC: gql`
    query userNameOtc(
      $userName: String!
      $password: String!
      $systemId: String!
      $recaptcha: String!
      $recaptchaVersion: String!
    ) {
      userNameOtc(
        userName: $userName
        password: $password
        systemId: $systemId
        recaptcha: $recaptcha
        recaptchaVersion: $recaptchaVersion
      ) {
        accountnumber
        onetimecode
        isR6
        isION
        ionServices
      }
    }
  `,
};

/**
 * @name getUserNameOtc
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to the userNameOtc
 */
export const getUserNameOtc = async (graphql, variables) => {
  try {
    const data = await queryClientSideGraphQL(graphql, {
      query: QUERIES.GET_USERNAME_OTC,
      variables,
    });
    return data;
  } catch (error) {
    throw new Error(error);
  }
};
